import { LandingPage } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type LandingPagesState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: LandingPagesState = {
  selected: [],
  query: '',
  names: {},
};

export const landingPagesSlice = createSlice({
  name: 'landing-pages',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<LandingPage>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<LandingPage[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((landingPage) => landingPage.id));
      action.payload.forEach((landingPage) => (state.names[landingPage.id] = landingPage.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = landingPagesSlice.actions;

export const getSelectedLandingPages = (state: RootState) => state.landingPages.selected;

export const getSelectedNamedLandingPages = (state: RootState) =>
  Object.entries(state.landingPages.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getLandingPagesQuery = (state: RootState) => state.landingPages.query;

export default landingPagesSlice.reducer;
